import prettyBytes from 'pretty-bytes';

export default function fileSizeFormat(row) {
	let fileSize = parseInt(row.fileSize);
	if (fileSize === 0) return ' ';
	else return prettyBytes(fileSize);
}
